import { Autosave, CreateAutosave, GetAutosave, IAutosaveBlob, DeleteAutosave } from "@samc/common";
import { EnumImportActions } from "@/Store/ImportModule";
import store from "./store";
import { DataImportAutosaveTask, IDataImportAutosaveBlob } from "./IDataImportAutosaveBlob";


export default  class ImportAutosave {

  private static autosave: Autosave<IDataImportAutosaveBlob> | null = null;
  private static storedetails = store;
  private static state: IDataImportAutosaveBlob = ImportAutosave.storedetails.getters.getState;
  private static abortController: AbortController | null = null;

  public static async updateAutosave() {
    if (!ImportAutosave.state.syncAutoSave) {
      return;
    }
    const autosaveBlob = ImportAutosave.getAutosaveBlob();
    if (autosaveBlob) {
      $log.info('Force update autosave', autosaveBlob);
      if (ImportAutosave.abortController !== null) {
        ImportAutosave.abortController.abort('Import Auto Save was called again');
        ImportAutosave.abortController = null;
      }

      ImportAutosave.abortController = new AbortController();
      try {
        await ImportAutosave.autosave?.sendUpdate(autosaveBlob.name, autosaveBlob.data, ImportAutosave.abortController);
        ImportAutosave.abortController = null;
      } catch (err: any) {
        if (err?.message !== undefined && err.message === 'canceled') $log.error(err)
      }
  
    }    
  }

  private static getAutosaveBlob(): IAutosaveBlob<IDataImportAutosaveBlob> | null {
    ImportAutosave.storedetails = store;
    ImportAutosave.state = ImportAutosave.storedetails.getters.getState;
    if (ImportAutosave.state == null) return null;
    if (ImportAutosave.state.metadata === null || ImportAutosave.state.fileSource === null || ImportAutosave.state.mapping === null) {
      return null;
    }
    let extraQueryParams = ImportAutosave.state.extraParams ?? null;
    let current = ImportAutosave.state.currentStep?.index ?? 0;
    let steps = ImportAutosave.state.steps ?? null;
    //To Do : To clean up the below code to remove hard codings
    if (steps != null && steps.length > 0) {
      for (let i = 0; i <= current; ++i) {
        if (steps[i] === null || steps[i] === undefined) continue;
        if (extraQueryParams)
          extraQueryParams['isDirty_' + steps[i].id] = (steps[i].component?.isDirty ?? false).toString();
      }
    }
    return {
      name: ImportAutosave.getAutosaveName(),
      data: {
        extraParams: extraQueryParams,
        metadata: ImportAutosave.state.metadata,
        basicMetadata: ImportAutosave.state.basicMetadata,
        fileSource: ImportAutosave.state.fileSource,
        mapping: ImportAutosave.state.mapping,
        mappingVersion: ImportAutosave.state.mappingVersion,
        step: ImportAutosave.state.step,
        enrichmentData: ImportAutosave.state.enrichmentData
      }
    }
  }

  private static getAutosaveName(): string {
    let name = '';
    let mapping = ImportAutosave.state?.mapping ?? null;
    if (mapping !== null && mapping.name !== null) {
      const group = mapping.group?.name
        ? `(Group ${mapping.group.name})`
        : '';

      name = `${mapping.name} ${group}`;
    }
    let fileSourceName = ImportAutosave.state?.fileSource?.name ?? null;
    if (fileSourceName !== null) {
      name = name + ` File: ${fileSourceName}`;
    }
    let currentStep = ImportAutosave.state?.currentStep ?? null;
    let steps = ImportAutosave.state?.steps ?? null;
    if (currentStep !== null && steps !== null && currentStep.index > -1)
      return name + ` On Step: ${steps[currentStep.index].title}`;
    else if (name)
      return name;
    else
      return $user?.name + '_' + Date.now();   
  }

  public static async initAutosave(autosaveId: number | null , verificationToken: string) {
    const autosaveIntervalInSeconds = 120;
    if (autosaveId !== 0 && autosaveId !== null) {
      ImportAutosave.autosave = await GetAutosave(DataImportAutosaveTask, autosaveId, verificationToken);
      const data = await ImportAutosave.autosave?.getDataAsync() ?? null;
      if (data) {
        let newState: IDataImportAutosaveBlob = { fileSource: data.fileSource, mapping: data.mapping, mappingVersion: data.mappingVersion, metadata: data.metadata, extraParams: data.extraParams, step: data.step, enrichmentData: data.enrichmentData }
        ImportAutosave.setState(newState);
        ImportAutosave.autosave?.startInterval(ImportAutosave.getAutosaveBlob, autosaveIntervalInSeconds);
        return ImportAutosave.autosave;
      } else {
        $log.warn('No data found for autosave ' + autosaveId);
        return ImportAutosave.autosave;
      }
    } else {
      if (ImportAutosave.state.syncAutoSave) {
        let newState: IDataImportAutosaveBlob = { fileSource: null, mapping: null, mappingVersion: null, metadata: null, extraParams: null, step: null, enrichmentData: null }
        ImportAutosave.setState(newState);
        ImportAutosave.autosave = await CreateAutosave(DataImportAutosaveTask, ImportAutosave.getAutosaveName(), verificationToken);
        ImportAutosave.autosave?.startInterval(ImportAutosave.getAutosaveBlob, autosaveIntervalInSeconds);
        return ImportAutosave.autosave;
      }
    }
  }

  public static async GetAutoSave(autosaveId: number | null , verificationToken: string): Promise<IDataImportAutosaveBlob> {
    if (autosaveId !== null && autosaveId !== null) {
      ImportAutosave.autosave = await GetAutosave(DataImportAutosaveTask, autosaveId, verificationToken);
      const data = await ImportAutosave.autosave?.getDataAsync() ?? null;
      if (data !== null) {
        if (data.fileSource !== null) {
          ImportAutosave.state.fileSource = data.fileSource;
        }
        if (data.metadata !== null) {
          ImportAutosave.state.metadata = data.metadata;
        }
        if (data.mapping !== null) {
          ImportAutosave.state.mapping = data.mapping;
        }
        if (data.mappingVersion !== null) {
          ImportAutosave.state.mappingVersion = data.mappingVersion;
        }
        if (data.extraParams !== null) {
          ImportAutosave.state.extraParams = data.extraParams;
        }
        if (data.step !== null) {
          ImportAutosave.state.step = data.step;
        }
        if (data.enrichmentData !== null) {
          ImportAutosave.state.enrichmentData = data.enrichmentData;
        }
        if (data.syncAutoSave !== null) {
          ImportAutosave.state.syncAutoSave = data.syncAutoSave;
        }
      }
    }
    return ImportAutosave.state;
  }

  public static async setState(state: IDataImportAutosaveBlob) {
    if (state !== null  &&  state.fileSource !== undefined) {
      await ImportAutosave.storedetails.dispatch(EnumImportActions.ActionSetFileSource, state.fileSource);
    }
    if (state !== null && state.basicMetadata !== undefined) {
      await ImportAutosave.storedetails.dispatch(EnumImportActions.ActionSetBasicMetadata, state.basicMetadata);
    }
    if (state !== null && state.metadata !== undefined) {
      await ImportAutosave.storedetails.dispatch(EnumImportActions.ActionSetMetadata, state.metadata);
    }
    if (state !== null && state.mapping !== undefined) {
      await ImportAutosave.storedetails.dispatch(EnumImportActions.ActionSetMapping, state.mapping);
    }
    if (state !== null && state.mappingVersion !== undefined) {
      await ImportAutosave.storedetails.dispatch(EnumImportActions.ActionSetMappingVersion, state.mappingVersion);
    }
    if (state !== null && state.enrichmentData !== undefined) {
      await ImportAutosave.storedetails.dispatch(EnumImportActions.ActionSetEnrichmentData, state.enrichmentData);
    }
    if (state !== null && state.step !== undefined) {
      await ImportAutosave.storedetails.dispatch(EnumImportActions.ActionSetStep, state.step);
      try {
        await ImportAutosave.updateAutosave();
      } catch (err: any) {
        if (err?.message !== undefined && err.message === 'cancelled') $log.error(err)
      }
    }
    if (state !== null &&  state.extraParams !== undefined) {
      await ImportAutosave.storedetails.dispatch(EnumImportActions.ActionSetExtraParams, state.extraParams);
    }
    if (state !== null && state.currentStep !== undefined) {
      await ImportAutosave.storedetails.dispatch(EnumImportActions.ActionSetCurrentStep, state.currentStep);
    }
    if (state !== null && state.steps !== undefined) {
      await ImportAutosave.storedetails.dispatch(EnumImportActions.ActionSetSteps, state.steps);
    }
    if (state !== null && state.syncAutoSave !== undefined) {
      await ImportAutosave.storedetails.dispatch(EnumImportActions.ActionSetSyncAutoSave, state.syncAutoSave);
    }
  }

  public static async deleteAutosave(autosaveId: number | null, verificationToken: string) {
    if (autosaveId !== null && autosaveId !== null) {
      return await DeleteAutosave(autosaveId, verificationToken);
    }
  }
}